interface ValidatorOptions
{
    [index: string]: any
}

export default abstract class AbstractValidator
{
    protected _value: any;

    protected _context: any;

    protected _options: ValidatorOptions;

    protected _error: string = '';

    protected messageTemplates: Record<string, string> = {};

    constructor(value: string, options: ValidatorOptions, context = {})
    {
        this._value   = value;
        this._context = context;
        this._options = options;
    }

    get error()
    {
        return this._error;
    }

    get value()
    {
        return this._value;
    }

    get context()
    {
        return this._context;
    }

    set error(errorMessage)
    {
        this._error = errorMessage;
    }

    getMessage(key: string)
    {
        let message = this._options && this._options.messages && this._options.messages[key] ? this._options.messages[key] : this.messageTemplates[key];

        return this.parseMessage(message);
    }

    parseMessage(message: string)
    {
        message = message.replace(`%value%`, this.value);

        //using regex ensures all occurrences get replaced
        for (let option in this._options) {
            if (this._options.hasOwnProperty(option)) {
                const regex = new RegExp(`%${option}%`, 'g');
                message = message.replace(regex, String(this._options[option]));
            }
        }

        return message;
    }

    abstract run(): void | boolean;
}